import { useState } from 'react';
import { ApiLocalStorage } from 'utils/ApiLocalStorage';
import { UserSearchResponse } from '../_types/user.types';
import { SEARCH_USER_DATA_KEY } from '../constantes/LocalStorageEnum';

export const useUserSearchStorage = () => {
  const [userSearchData, setUserSearchData] = useState<UserSearchResponse | null>(() => {
    try {
      const storedData = ApiLocalStorage.get(SEARCH_USER_DATA_KEY);
      
      // ApiLocalStorage.get já faz JSON.parse, então não precisamos fazer novamente
      if (storedData && typeof storedData === 'object') {
        return storedData;
      }
      
      return null;
    } catch (error) {
      console.error('Error parsing stored user data:', error);
      
      return null;
    }
  });
  
  const setUserData = (data: UserSearchResponse | null) => {
    try {
      if (data) {
        // ApiLocalStorage.set já faz JSON.stringify, então não precisamos fazer novamente
        ApiLocalStorage.set(SEARCH_USER_DATA_KEY, data);
        setUserSearchData(data);
      } else {
        ApiLocalStorage.remove(SEARCH_USER_DATA_KEY);
        setUserSearchData(null);
      }
    } catch (error) {
      console.error('Error saving user data:', error);
      ApiLocalStorage.remove(SEARCH_USER_DATA_KEY);
      setUserSearchData(null);
    }
  };
  
  const updateUserData = (newData: Partial<UserSearchResponse>) => {
    try {
      const updatedData = {
        ...userSearchData,
        ...newData
      } as UserSearchResponse;
      
      // ApiLocalStorage.set já faz JSON.stringify
      ApiLocalStorage.set(SEARCH_USER_DATA_KEY, updatedData);
      setUserSearchData(updatedData);
    } catch (error) {
      console.error('Error updating user data:', error);
    }
  };
  
  const clearUserData = () => {
    ApiLocalStorage.remove(SEARCH_USER_DATA_KEY);
    setUserSearchData(null);
  };
  
  return {
    userData: userSearchData,
    setUserData,
    clearUserData,
    hasUserData: Boolean(userSearchData),
    updateUserData
  };
};
